import { render, staticRenderFns } from "./ParametersModal.vue?vue&type=template&id=95c6d3fe&scoped=true&"
import script from "./ParametersModal.vue?vue&type=script&lang=js&"
export * from "./ParametersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c6d3fe",
  null
  
)

export default component.exports